import { RootState } from "../rootReducer";

export const selectIsLoading = (state: RootState) => state.updateUser.loading;
export const csvDownloadErrorMessage = (state: RootState) =>
  state.csvDownloadUser.error;
export const csvDownloadSuccessResponse = (state: RootState) =>
  state.csvDownloadUser.csvDownloadUserResponse;
